export default "__VITE_ASSET__BkN2SA1x__"